var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import GoodService from "../../../api/GoodService";
import { Loading } from 'element-ui';
import _ from 'lodash';
import ArticleList from "../../../components/alert/ArticleList.vue";
var Specification = (function (_super) {
    __extends(Specification, _super);
    function Specification() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Specification.prototype.created = function () {
        this.service = GoodService.getInstance();
    };
    Specification.prototype.toSave = function (index, row) {
        var _this = this;
        if (!row.sales_unit_coefficient || !(/^\d+(\.\d+)?$/.test(row.sales_unit_coefficient))) {
            this.$message.error("请填写正确的销售系数！");
            return;
        }
        var params = _.extend(row, { goods_id: this.goods_id });
        delete params.edit;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.saveGoodsFormat(params).then(function (res) {
            loadingInstance.close();
            if (res.data.code == 0) {
                _this.$message.success("保存成功");
                _this.$emit('refreshFormat');
                _this.$emit('editFormat', index, false);
                return;
            }
            var instance = _this.$dialog(ArticleList, {
                data: {
                    resData: res.data,
                    modelType: 'specAndGood',
                    sureButtonText: res.data.code == 12 ? "确定" : '知道了'
                }
            }, {
                title: "提示",
                width: 450,
                height: 350,
                closeBtn: false,
            }).instance;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    Specification.prototype.toEdit = function (index) {
        this.$emit('editFormat', index, true);
    };
    Specification.prototype.toDelete = function (index, goods_format_id, doFlag) {
        var _this = this;
        if (doFlag === void 0) { doFlag = 0; }
        if (goods_format_id) {
            var params_1 = { goods_format_id: goods_format_id, do: doFlag };
            var loadingInstance_1 = Loading.service({ fullscreen: true });
            this.service.deleteGoodsFormat(params_1).then(function (res) {
                loadingInstance_1.close();
                if (res.data.code == 0) {
                    _this.$message.success("删除成功");
                    _this.$emit('refreshFormat');
                    return;
                }
                var instance = _this.$dialog(ArticleList, {
                    data: {
                        resData: res.data,
                        modelType: 'specAndGood',
                        sureButtonText: res.data.code == 12 ? "确定" : '知道了',
                        showCancelButton: res.data.code == 12
                    }
                }, {
                    title: "提示",
                    width: 450,
                    height: 350,
                    closeBtn: false,
                }).instance;
                instance.$on("addClient:ok", function (data) {
                    if (res.data.code == 12) {
                        var confirmStr = res.data.data.confirm;
                        var delParams = Object.assign({}, params_1, {
                            confirm: confirmStr
                        });
                        var loadingInstance_2 = Loading.service({ fullscreen: true });
                        _this.service.deleteGoodsFormat(delParams).then(function (res) {
                            loadingInstance_2.close();
                            if (res.data.code == 0) {
                                _this.$message.success("删除成功");
                                _this.$emit('refreshFormat');
                                return;
                            }
                            var instance = _this.$dialog(ArticleList, {
                                data: {
                                    resData: res.data,
                                    modelType: 'specAndGood',
                                    sureButtonText: res.data.code == 12 ? "确定" : '知道了'
                                }
                            }, {
                                title: "提示",
                                width: 450,
                                height: 350,
                                closeBtn: false,
                            }).instance;
                        });
                    }
                });
            }).catch(function (err) {
                loadingInstance_1.close();
                _this.$message.error(err.message || err.msg);
            });
        }
        else {
            this.$emit('deleteGoodsFormat', index);
        }
    };
    __decorate([
        Prop({
            type: Array
        })
    ], Specification.prototype, "goods_format_list", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], Specification.prototype, "stdList", void 0);
    __decorate([
        Prop({
            type: Number
        })
    ], Specification.prototype, "goods_id", void 0);
    __decorate([
        Prop({
            type: Boolean
        })
    ], Specification.prototype, "operateShow", void 0);
    Specification = __decorate([
        Component({})
    ], Specification);
    return Specification;
}(Vue));
export default Specification;
